import React from 'react';
import {
  Box,
  Flex,
  Grid,
  Heading,
  Text,
  Icon,
  Button,
  Avatar,
  VStack,
  HStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Badge
} from '@chakra-ui/react';
import { 
  FaUsers, 
  FaTwitter, 
  FaTrophy, 
  FaRegHeart, 
  FaRetweet, 
  FaStore,
  FaCoins,
  FaExternalLinkAlt,
  FaTicketAlt,
  FaGavel
} from 'react-icons/fa';

const CommunityActivityHub = ({ recentActivity, goldColor }) => {
  return (
    <>
      {/* Twitter Feed and Marketplace Activity */}
      <Box 
        p={4} 
        bg="rgba(23, 25, 35, 0.9)"
        borderRadius="lg"
        borderWidth="1px"
        borderColor="purple.500"
        boxShadow="0 0 15px rgba(149, 128, 255, 0.2)"
        mb={4}
      >
        <Heading size="md" color="white" mb={4} display="flex" alignItems="center">
          <Icon as={FaUsers} mr={2} color="purple.400" />
          Community Activity Hub
        </Heading>
        
        <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={4}>
          {/* Twitter Feed */}
          <Box 
            borderWidth="1px" 
            borderColor="gray.700" 
            borderRadius="md" 
            p={3} 
            bg="rgba(13, 16, 25, 0.7)"
            h="280px"
            overflowY="auto"
          >
            <Flex justify="space-between" align="center" mb={3}>
              <Heading size="xs" color="twitter.400" display="flex" alignItems="center">
                <Icon as={FaTwitter} mr={2} />
                Latest Updates
              </Heading>
              <Button size="xs" leftIcon={<FaTwitter />} colorScheme="twitter" variant="outline">
                Follow
              </Button>
            </Flex>
            
            <VStack spacing={2} align="stretch">
              {[
                {
                  id: 1,
                  user: "PalmHeist",
                  handle: "@PalmHeistNFT",
                  avatar: "/images/logo.png",
                  content: "Exciting news! We've just released our new marketplace feature with enhanced trading capabilities! #NFT #Solana",
                  time: "2h ago",
                  likes: 128,
                  retweets: 42
                },
                {
                  id: 2,
                  user: "PalmHeist",
                  handle: "@PalmHeistNFT",
                  avatar: "/images/logo.png",
                  content: "Join us for our community AMA this Friday at 3PM UTC. We'll be discussing upcoming features and answering your questions! #PalmHeistAMA",
                  time: "5h ago",
                  likes: 89,
                  retweets: 31
                },
                {
                  id: 3,
                  user: "PalmHeist",
                  handle: "@PalmHeistNFT",
                  avatar: "/images/logo.png",
                  content: "Congratulations to @CryptoWhale for winning yesterday's progressive jackpot of 50,000 JINU! 🎉 #BigWin #PalmHeist",
                  time: "1d ago",
                  likes: 215,
                  retweets: 76
                },
                {
                  id: 4,
                  user: "PalmHeist",
                  handle: "@PalmHeistNFT",
                  avatar: "/images/logo.png",
                  content: "Our lending pool has now surpassed 1M JINU in total value locked! Thanks to all our amazing lenders for your support! #DeFi #Solana",
                  time: "2d ago",
                  likes: 176,
                  retweets: 58
                }
              ].map(tweet => (
                <Box key={tweet.id} p={2} borderWidth="1px" borderColor="gray.700" borderRadius="md">
                  <Flex mb={1}>
                    <Avatar size="xs" name={tweet.user} src={tweet.avatar} mr={2} />
                    <Box>
                      <Text fontWeight="bold" fontSize="xs">{tweet.user}</Text>
                      <Text fontSize="2xs" color="gray.500">{tweet.handle}</Text>
                    </Box>
                    <Text fontSize="2xs" color="gray.500" ml="auto">{tweet.time}</Text>
                  </Flex>
                  <Text fontSize="xs" mb={1}>{tweet.content}</Text>
                  <Flex justify="space-between">
                    <HStack spacing={4}>
                      <Flex align="center">
                        <Icon as={FaRegHeart} color="gray.500" mr={1} fontSize="10px" />
                        <Text fontSize="2xs" color="gray.500">{tweet.likes}</Text>
                      </Flex>
                      <Flex align="center">
                        <Icon as={FaRetweet} color="gray.500" mr={1} fontSize="10px" />
                        <Text fontSize="2xs" color="gray.500">{tweet.retweets}</Text>
                      </Flex>
                    </HStack>
                  </Flex>
                </Box>
              ))}
            </VStack>
          </Box>
          
          {/* Marketplace Activity */}
          <Box 
            borderWidth="1px" 
            borderColor="gray.700" 
            borderRadius="md" 
            p={3} 
            bg="rgba(13, 16, 25, 0.7)"
            h="280px"
            overflowY="auto"
          >
            <Heading size="xs" color="purple.400" mb={3} display="flex" alignItems="center">
              <Icon as={FaStore} mr={2} />
              Recent Marketplace Activity
            </Heading>
            
            <VStack spacing={2} align="stretch">
              {[
                {
                  id: 1,
                  type: "SALE",
                  item: "Golden Key #1234",
                  price: 2.5,
                  buyer: "CryptoWhale",
                  seller: "NFTCollector",
                  time: "35m ago"
                },
                {
                  id: 2,
                  type: "LISTING",
                  item: "Golden Key #5678",
                  price: 3.2,
                  seller: "SolanaFan",
                  time: "1h ago"
                },
                {
                  id: 3,
                  type: "RAFFLE",
                  item: "Golden Key #9101",
                  price: 1.8,
                  buyer: "JINULover",
                  seller: "BlockchainGuru",
                  time: "3h ago"
                },
                {
                  id: 4,
                  type: "AUCTION",
                  item: "Golden Key #1121",
                  price: 4.0,
                  seller: "NFTTrader",
                  time: "5h ago"
                },
                {
                  id: 5,
                  type: "DEAL",
                  item: "Golden Key #3141",
                  price: 2.2,
                  buyer: "TreasureHunter",
                  seller: "PirateKing",
                  time: "8h ago"
                }
              ].map(activity => (
                <Box 
                  key={activity.id} 
                  p={2} 
                  borderWidth="1px" 
                  borderColor="gray.700" 
                  borderRadius="md"
                  bg={activity.type === "SALE" ? "rgba(128, 90, 213, 0.1)" : "transparent"}
                >
                  <Flex justify="space-between" align="center" mb={1}>
                    <Badge 
                      colorScheme={activity.type === "SALE" ? "purple" : activity.type === "LISTING" ? "blue" : activity.type === "RAFFLE" ? "green" : activity.type === "AUCTION" ? "orange" : "pink"} 
                      fontSize="2xs"
                    >
                      {activity.type}
                    </Badge>
                    <Text fontSize="2xs" color="gray.500">{activity.time}</Text>
                  </Flex>
                  <Text fontSize="xs" fontWeight="bold" mb={1}>{activity.item}</Text>
                  <Flex justify="space-between" align="center">
                    <HStack spacing={1}>
                      <Icon as={FaCoins} color="yellow.400" fontSize="10px" />
                      <Text fontSize="xs" color="yellow.400" fontWeight="bold">{activity.price} SOL</Text>
                    </HStack>
                    <Text fontSize="2xs">
                      {activity.type === "SALE" 
                        ? `${activity.buyer} from ${activity.seller}` 
                        : activity.type === "LISTING" 
                          ? `by ${activity.seller}` 
                          : activity.type === "RAFFLE" 
                            ? `${activity.buyer} won from ${activity.seller}` 
                            : activity.type === "AUCTION" 
                              ? `by ${activity.seller}` 
                              : `${activity.buyer} from ${activity.seller}`}
                    </Text>
                  </Flex>
                  <Button 
                    size="xs" 
                    mt={1} 
                    width="100%" 
                    colorScheme={
                      activity.type === "SALE" ? "purple" : 
                      activity.type === "LISTING" ? "blue" : 
                      activity.type === "RAFFLE" ? "green" : 
                      activity.type === "AUCTION" ? "orange" : 
                      "pink"
                    }
                    variant="outline"
                    fontSize="2xs"
                    height="20px"
                    leftIcon={
                      activity.type === "RAFFLE" ? <Icon as={FaTicketAlt} fontSize="10px" /> : 
                      activity.type === "AUCTION" ? <Icon as={FaGavel} fontSize="10px" /> : 
                      <Icon as={FaExternalLinkAlt} fontSize="10px" />
                    }
                  >
                    {activity.type === "SALE" ? "View Details" : 
                     activity.type === "LISTING" ? "View Listing" : 
                     activity.type === "RAFFLE" ? "Enter Raffle" : 
                     activity.type === "AUCTION" ? "Place Bid" : 
                     "View Deal"}
                  </Button>
                </Box>
              ))}
            </VStack>
          </Box>
        </Grid>
      </Box>
      
      {/* Community Leaderboard as a separate section */}
      <Box 
        p={4} 
        bg="rgba(23, 25, 35, 0.9)"
        borderRadius="lg"
        borderWidth="1px"
        borderColor="yellow.500"
        boxShadow="0 0 15px rgba(255, 215, 0, 0.2)"
        mb={4}
      >
        <Heading size="md" color="white" mb={4} display="flex" alignItems="center">
          <Icon as={FaTrophy} mr={2} color="yellow.400" />
          Community Leaderboard
        </Heading>
        
        <Tabs variant="soft-rounded" colorScheme="yellow" size="xs" isFitted>
          <TabList>
            <Tab>Lenders</Tab>
            <Tab>Traders</Tab>
            <Tab>Collectors</Tab>
          </TabList>
          <TabPanels>
            <TabPanel p={2}>
              <Box h="200px" overflowY="auto">
                <VStack spacing={2} align="stretch">
                  {[
                    { rank: 1, user: "CryptoWhale", amount: 250000, badge: "WHALE" },
                    { rank: 2, user: "SolanaFan", amount: 120000, badge: "SHARK" },
                    { rank: 3, user: "JINULover", amount: 85000, badge: "DOLPHIN" },
                    { rank: 4, user: "NFTCollector", amount: 45000, badge: "FISH" },
                    { rank: 5, user: "BlockchainGuru", amount: 25000, badge: "FISH" },
                    { rank: 6, user: "SolTrader", amount: 18000, badge: "FISH" },
                    { rank: 7, user: "CryptoKing", amount: 15000, badge: "FISH" },
                    { rank: 8, user: "TokenMaster", amount: 12000, badge: "FISH" },
                    { rank: 9, user: "JINUHodler", amount: 10000, badge: "FISH" },
                    { rank: 10, user: "SolGuru", amount: 8000, badge: "FISH" }
                  ].map(leader => (
                    <Flex 
                      key={leader.rank} 
                      justify="space-between" 
                      align="center" 
                      p={2} 
                      borderWidth="1px" 
                      borderColor="gray.700" 
                      borderRadius="md"
                      bg={leader.rank === 1 ? "rgba(255, 215, 0, 0.1)" : "transparent"}
                    >
                      <Flex align="center">
                        <Text fontWeight="bold" color={leader.rank === 1 ? goldColor : "white"} mr={2}>#{leader.rank}</Text>
                        <Avatar size="xs" name={leader.user} mr={2} />
                        <Text fontSize="xs">{leader.user}</Text>
                      </Flex>
                      <Flex align="center">
                        <Text fontSize="xs" color={goldColor} fontWeight="bold" mr={2}>{leader.amount.toLocaleString()} JINU</Text>
                        <Badge colorScheme={leader.rank === 1 ? "yellow" : "gray"} fontSize="2xs">{leader.badge}</Badge>
                      </Flex>
                    </Flex>
                  ))}
                </VStack>
              </Box>
            </TabPanel>
            <TabPanel p={2}>
              <Box h="200px" overflowY="auto">
                <VStack spacing={2} align="stretch">
                  {[
                    { rank: 1, user: "NFTTrader", amount: 185, badge: "LEGEND" },
                    { rank: 2, user: "PirateKing", amount: 142, badge: "PRO" },
                    { rank: 3, user: "TreasureHunter", amount: 98, badge: "EXPERT" },
                    { rank: 4, user: "GoldenKey", amount: 76, badge: "SKILLED" },
                    { rank: 5, user: "SolanaWhale", amount: 54, badge: "NOVICE" },
                    { rank: 6, user: "CryptoNinja", amount: 42, badge: "NOVICE" },
                    { rank: 7, user: "TokenFlip", amount: 38, badge: "NOVICE" },
                    { rank: 8, user: "NFTGuru", amount: 32, badge: "NOVICE" },
                    { rank: 9, user: "SolTrader", amount: 28, badge: "NOVICE" },
                    { rank: 10, user: "CryptoTrader", amount: 25, badge: "NOVICE" }
                  ].map(leader => (
                    <Flex 
                      key={leader.rank} 
                      justify="space-between" 
                      align="center" 
                      p={2} 
                      borderWidth="1px" 
                      borderColor="gray.700" 
                      borderRadius="md"
                      bg={leader.rank === 1 ? "rgba(255, 215, 0, 0.1)" : "transparent"}
                    >
                      <Flex align="center">
                        <Text fontWeight="bold" color={leader.rank === 1 ? goldColor : "white"} mr={2}>#{leader.rank}</Text>
                        <Avatar size="xs" name={leader.user} mr={2} />
                        <Text fontSize="xs">{leader.user}</Text>
                      </Flex>
                      <Flex align="center">
                        <Text fontSize="xs" color={goldColor} fontWeight="bold" mr={2}>{leader.amount} trades</Text>
                        <Badge colorScheme={leader.rank === 1 ? "yellow" : "gray"} fontSize="2xs">{leader.badge}</Badge>
                      </Flex>
                    </Flex>
                  ))}
                </VStack>
              </Box>
            </TabPanel>
            <TabPanel p={2}>
              <Box h="200px" overflowY="auto">
                <VStack spacing={2} align="stretch">
                  {[
                    { rank: 1, user: "KeyMaster", amount: 42, badge: "LEGEND" },
                    { rank: 2, user: "NFTWhale", amount: 36, badge: "PRO" },
                    { rank: 3, user: "ArtCollector", amount: 29, badge: "EXPERT" },
                    { rank: 4, user: "SolanaKing", amount: 24, badge: "SKILLED" },
                    { rank: 5, user: "CryptoArtist", amount: 18, badge: "NOVICE" },
                    { rank: 6, user: "TokenHunter", amount: 15, badge: "NOVICE" },
                    { rank: 7, user: "NFTHunter", amount: 13, badge: "NOVICE" },
                    { rank: 8, user: "KeyCollector", amount: 11, badge: "NOVICE" },
                    { rank: 9, user: "TreasureFinder", amount: 9, badge: "NOVICE" },
                    { rank: 10, user: "GoldenFinder", amount: 8, badge: "NOVICE" }
                  ].map(leader => (
                    <Flex 
                      key={leader.rank} 
                      justify="space-between" 
                      align="center" 
                      p={2} 
                      borderWidth="1px" 
                      borderColor="gray.700" 
                      borderRadius="md"
                      bg={leader.rank === 1 ? "rgba(255, 215, 0, 0.1)" : "transparent"}
                    >
                      <Flex align="center">
                        <Text fontWeight="bold" color={leader.rank === 1 ? goldColor : "white"} mr={2}>#{leader.rank}</Text>
                        <Avatar size="xs" name={leader.user} mr={2} />
                        <Text fontSize="xs">{leader.user}</Text>
                      </Flex>
                      <Flex align="center">
                        <Text fontSize="xs" color={goldColor} fontWeight="bold" mr={2}>{leader.amount} NFTs</Text>
                        <Badge colorScheme={leader.rank === 1 ? "yellow" : "gray"} fontSize="2xs">{leader.badge}</Badge>
                      </Flex>
                    </Flex>
                  ))}
                </VStack>
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </>
  );
};

export default CommunityActivityHub;
